import { VFC } from "./types";
import AdminManagement from "./adminManagement/AdminManagement";
import PoleManagement from "./poleManagement/PoleManagement";

import RolesAndPermission from "./adminManagement/RolesAndPermission";
import Loader from "components/Loader";
import NonPartnerClubManagement from "./nonPartnerManagement/nonPartnerClub/nonPartnerClubManagement";
import NonPartnerPlayerManagement from "./nonPartnerManagement/nonPartnerPlayers/nonPartnerPlayerManagement";
import CountrtyExpansion from "./countryExpansion/CountryExpansion";
import React, { useCallback, useEffect, useState } from "react";
import NotificationManagement from "./notificationManagement/NotificationManagement";
import client from "libs/client";
import { continentCountries } from "./types";
import Migrate from "./nonPartnerManagement/migrate/Migrate";
import { ApiManagement } from "./apiManagement/ApiManagement";
import { DuplicatePlayersPage } from "../DuplicatePlayersPage";
interface HomeSectionProps {
	activeMenu: string;
	onMenuClick: (id: string) => void;
}

const Section: VFC<HomeSectionProps> = ({ activeMenu, onMenuClick }) => {
	const userRolePermissions: {
		id: number;
		permission: string;
		resource: string;
	}[] = [];

	const isSuperAdmin = true;

	const [activeClub, setActiveClub] = useState(null);
	const [countries, setCountries] = useState<{ [key: string]: string }>({});
	const [countriesWithContinents, setCountriesWithContinents] = useState<continentCountries[]>([]);

	const onPlayerCountClick = (club: any) => {
		onMenuClick("non_partner_player");
		setActiveClub(club);
	};

	const getCountriesData = useCallback(async () => {
		const response = await client.allCountries.query().then((res) => {
			return res?.data as { [key: string]: string };
		});
		setCountries(response);
		const continentResponse = await client.getContinentCountry.query().then((res) => {
			return res?.data;
		});
		setCountriesWithContinents(continentResponse);
	}, []);

	useEffect(() => {
		if (activeMenu === "non_partner_club") setActiveClub(null);
	}, [activeMenu]);

	useEffect(() => {
		getCountriesData();
	}, [getCountriesData]);

	return (
		<>
			<section className="home-section">
				<div className="home-content product-management-right">
					{activeMenu === "" && <Loader />}
					<section className={activeMenu === "non_partner_player" ? "show" : "hide"}>
						<NonPartnerPlayerManagement activeMenu={activeMenu} activeClub={activeClub} countries={countries} />
					</section>
					<section className={activeMenu === "non_partner_club" ? "show" : "hide"}>
						<NonPartnerClubManagement
							activeMenu={activeMenu}
							countries={countries}
							countriesWithContinents={countriesWithContinents}
							onPlayerCountClick={onPlayerCountClick}
						/>
					</section>
					<section className={activeMenu === "migrations" ? "show" : "hide"}>
						<Migrate type="any" activeMenu={activeMenu} countries={countries} />
					</section>
					<section className={activeMenu === "poles" ? "show" : "hide"}>
						<PoleManagement activeMenu={activeMenu} />
					</section>
					<section className={activeMenu === "admin_creation" ? "show" : "hide"}>
						<AdminManagement activeMenu={activeMenu} />
					</section>
					<section className={activeMenu === "die_ligen" ? "show" : "hide"}>
						<ApiManagement activeMenu={activeMenu} />
					</section>
					<section className={activeMenu === "roles_permissions_management" ? "show" : "hide"}>
						{isSuperAdmin ? (
							<RolesAndPermission activeMenu={activeMenu} />
						) : (
							userRolePermissions &&
							userRolePermissions.filter((permission) => permission.resource === "roles_permissions_management").length > 0 && (
								<RolesAndPermission activeMenu={activeMenu} />
							)
						)}
					</section>
					<section className={activeMenu === "specific_notifications" ? "show" : "hide"}>
						<NotificationManagement activeMenu={activeMenu} />
					</section>

					<section className={activeMenu === "country_expansion" ? "show" : "hide"}>
						<CountrtyExpansion
							activeMenu={activeMenu}
							countries={Object.entries(countries).map(([code, label]) => ({ label, value: code }))}
							countriesWithContinents={countriesWithContinents}
						/>
					</section>
					<section className={activeMenu === "user_duplicates" ? "show" : "hide"}>
						<DuplicatePlayersPage countries={countries} />
					</section>
				</div>
			</section>
		</>
	);
};

export default Section;
